import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../shared';

import {
    Activate,
    Password,
    PasswordResetInit,
    PasswordResetFinish,
    SessionsService,
    SessionsComponent,
    PasswordStrengthBarComponent,
    ActivateComponent,
    PasswordComponent,
    PasswordResetInitComponent,
    PasswordResetFinishComponent,
    SettingsComponent,
    accountState
} from './';

@NgModule( {
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot( accountState, { useHash: true } )
    ],
    declarations: [
        ActivateComponent,
        PasswordComponent,
        PasswordStrengthBarComponent,
        PasswordResetInitComponent,
        PasswordResetFinishComponent,
        SessionsComponent,
        SettingsComponent
    ],
    providers: [
        SessionsService,
        Activate,
        Password,
        PasswordResetInit,
        PasswordResetFinish
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
} )
export class DeviceConfigurerServiceAccountModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/account.module.ts